export function validateEmaIntersectsFirstCandle(data) {
  const {
    firstCandleCandleDuration,
    emaCandleDuration,
    periodLengths,
    candleBarrier,
    direction,
    tradePlan,
  } = data;
  if (
    !firstCandleCandleDuration ||
    firstCandleCandleDuration <= 0 ||
    !Number.isInteger(firstCandleCandleDuration)
  )
    return [
      false,
      'Please provide a positive, whole number for candle durations.',
    ];

  if (
    !emaCandleDuration ||
    emaCandleDuration <= 0 ||
    !Number.isInteger(emaCandleDuration)
  )
    return [
      false,
      'Please provide a positive, whole number for candle durations.',
    ];
  if (!periodLengths || periodLengths?.length === 0)
    return [false, 'Please provide at least one period length.'];
  if (!candleBarrier || candleBarrier === '' || !direction || direction === '')
    return [false, 'Candle Barrier or Direction is not defined.'];
  if (tradePlan.goLong && tradePlan.goShort)
    return [
      false,
      'EMA Intersects First Candle candle cannot be long and short.',
    ];
  return [true, ''];
}
